import { API_BASE_URL } from './api';
import { authService } from './authService';

export interface BlockedUser {
  userId: string;
  displayName: string;
  profilePhotoUrl?: string | null;
  createdAt: string;
}

const authJsonHeaders = () => ({ 'Content-Type': 'application/json', ...authService.getAuthHeaders() });

// A block is silent and symmetric in effect: neither side sees the other's posts, comments,
// profile or discovery listing, and neither can message, follow, or send buddy requests. It
// also removes any existing buddy/follow tie. The blocked user is never told, and can never
// see that they were blocked.
export const blockService = {
  block: async (blockedUserId: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/blocks`, {
      method: 'POST',
      headers: authJsonHeaders(),
      body: JSON.stringify({ blockedUserId }),
    });
    if (!res.ok) throw new Error((await res.text()) || 'Failed to block user');
  },

  unblock: async (blockedUserId: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/blocks/${encodeURIComponent(blockedUserId)}`, {
      method: 'DELETE',
      headers: { ...authService.getAuthHeaders() },
    });
    if (!res.ok) throw new Error('Failed to unblock user');
  },

  getBlocked: async (): Promise<BlockedUser[]> => {
    const res = await fetch(`${API_BASE_URL}/blocks`, { headers: { ...authService.getAuthHeaders() } });
    if (!res.ok) throw new Error('Failed to load blocked accounts');
    return res.json();
  },
};
